import type { TutorialDefinition } from './types'

// Definição mínima v1 para scaffold; será expandida depois
export const FIRST_RUN_DEFINITION: TutorialDefinition = {
  id: 'first_run',
  version: 1,
  steps: [
    {
      id: 'first_run.step_00_intro',
      text: 'Olá, me chamo Apis! Seja bem-vindo ao Magistral. Eu serei sua guia nos seus primeiros passos, até aprender a mexer no aplicativo.',
      gate: 'soft',
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Sem_Fundo.mov', webm: '/Imagens/Apis_Video_Sem_Fundo_webm.webm' },
      layoutOverride: {
        character: {
          scale: 1.6,  // 60% maior que padrão (240px → 384px visual)
        },
      },
      enableStaggeredAnimation: true,  // ✅ Pop-in elegante com sequência escalonada
    },
    {
      id: 'first_run.step_01_welcome',
      text: 'Você pode avançar, ou pular o tutorial a qualquer momento que quiser',
      gate: 'soft',
      characterPose: 'feliz',
      layoutOverride: {
        character: {
          right: '3%',    // 5% mais à direita (era 24px fixo)
          bottom: '8%',   // 5% mais para cima (era 24px fixo)
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_02_route_setup_family',
      text: 'Vamos para a tela de configuração da família para começarmos.',
      gate: 'hard',
      waitFor: { type: 'route', path: '/setup-family' },
    },
    {
      id: 'first_run.step_03_01_family_name',
      text: 'Digite o nome da sua família no campo abaixo.',
      anchor: 'input-family-name',
      gate: 'hard',
      waitFor: { type: 'event', name: 'tutorial:family:name:started' },
      waitAction: 'unlock',
      layoutOverride: {
        character: {
          bottom: '10%', // 5% mais para cima em relação ao padrão
        },
        tail: {
          placement: 'top',
          offsetX: 40,
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_03_02_family_continue',
      text: 'Ótimo! Agora toque em "Continuar" para criar a família.',
      anchor: 'btn-continue-create-family',
      gate: 'hard',
      waitFor: { type: 'click', anchor: 'btn-continue-create-family' },
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando.mov', webm: '/Imagens/Apis_Video_Apontando_webm.webm' },
      layoutOverride: {
        character: {
          bottom: '10%',
          scale: 1.263,
        },
        tail: {
          placement: 'top',
          offsetX: 90,
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_01_member_name',
      text: 'Vamos começar o primeiro membro. Digite o nome completo.',
      anchor: 'member-name-input',
      gate: 'hard',
      waitFor: { type: 'event', name: 'tutorial:member:name-filled' },
      waitAction: 'unlock',
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Lado_Direito.mov', webm: '/Imagens/Apis_Video_Lado_Direito_webm.webm' },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_02_member_birthdate',
      text: 'Agora informe a data de nascimento.',
      anchor: 'member-birthdate-input',
      gate: 'hard',
      waitFor: { type: 'event', name: 'tutorial:member:birthdate-filled' },
      waitAction: 'unlock',
      layoutOverride: {
        character: {
          bottom: '32%',
        },
        bubble: {
          bottom: '30%',
        },
        controls: {
          bottom: '25%',
        },
        tail: {
          placement: 'top',
          offsetX: 90,
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_03_gender',
      text: 'Selecione o sexo para personalizarmos o avatar.',
      anchor: 'member-gender-select',
      gate: 'hard',
      waitFor: { type: 'event', name: 'tutorial:member:gender-selected' },
      characterPose: 'pensando',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_04_avatar_select',
      text: 'Escolha um avatar na grade ou toque em "Selecionar foto do dispositivo" para enviar uma imagem sua.',
      anchor: 'member-avatar-combined',
      gate: 'hard',
      waitFor: { type: 'event', name: 'tutorial:avatar:selected' },
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_05_add_member_cta',
      text: 'Pronto! Toque em "Adicionar Membro".',
      anchor: 'btn-add-member',
      gate: 'hard',
      waitFor: { type: 'click', anchor: 'btn-add-member' },
      uiPosition: 'center-up',
      layoutOverride: {
        controls: {
          top: 'calc(45% + 140px + 3vh)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_04_06_continue_or_more',
      text: 'Você pode cadastrar outros membros ou seguir para o próximo passo tocando em Continuar.',
      anchor: 'btn-continue-add-members',
      gate: 'hard',
      waitFor: { type: 'click', anchor: 'btn-continue-add-members' },
      uiPosition: 'center-up',
      layoutOverride: {
        controls: {
          top: 'calc(45% + 140px + 3vh)',
        },
      },
      enableStaggeredAnimation: true,
    },
    // 05 - Dashboard (misto)
    {
      id: 'first_run.step_05_01_dashboard_intro',
      text: 'Bem-vindo ao seu painel! Aqui você acompanha os pontos e o nível da família.',
      gate: 'hard',
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Basico.mov', webm: '/Imagens/Apis_Video_Basico_webm.webm' },
      layoutOverride: {
        character: {
          marginTop: -24,
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_05_01_01_curiosity_offer',
      text: 'Antes de prosseguir, quer ouvir uma curiosidade sobre Homeopatia?',
      gate: 'hard',
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Curiosa.mov', webm: '/Imagens/Apis_Video_Curiosa_webm.webm' },
      layoutOverride: {
        character: {
          marginTop: -24,
          scale: 1.1,
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_05_02_curiosities',
      text: 'Toque no logo para ver curiosidades quando estiverem disponíveis. Elas rendem pontos! (Opcional)',
      gate: 'hard',
      anchor: 'btn-open-curiosities',
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando.mov', webm: '/Imagens/Apis_Video_Apontando_webm.webm' },
      layoutOverride: {
        character: {
          marginTop: '-25%',
        },
        controls: {
          top: 'calc(33% + 190px)',
        },
      },
      waitFor: { type: 'click', anchor: 'btn-open-curiosities' },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_05_03_curiosity_mark_read',
      text: 'Toque em “Marcar como Lida (+10 pontos)” para ganhar pontos desta curiosidade.',
      gate: 'hard',
      anchor: 'btn-fact-mark-read',
      waitFor: { type: 'click', anchor: 'btn-fact-mark-read' },
      overlay: false,
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_05_05_add_treatment',
      text: 'Vamos cadastrar seu primeiro tratamento. Toque em “Adicionar Tratamento”.',
      gate: 'hard',
      anchor: 'btn-add-treatment',
      waitFor: { type: 'click', anchor: 'btn-add-treatment' },
      uiPosition: 'center-up',
      characterVideo: { mov: '/Imagens/Apis_Video_Remedio.mov', webm: '/Imagens/Apis_Video_Remedio_webm.webm' },
      layoutOverride: {
        character: {
          scale: 1.15,
        },
        controls: {
          top: 'calc(45% + 140px + 3vh)',
        },
      },
      enableStaggeredAnimation: true,
    },
    // 06 - Primeira Medicação (hard)
    {
      id: 'first_run.step_06_01_open_member_menu',
      text: 'No membro, toque no menu de opções (três pontinhos).',
      gate: 'hard',
      anchor: 'member-menu-ellipsis',
      waitFor: { type: 'click', anchor: 'member-menu-ellipsis' },
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando_Esquerda.mov', webm: '/Imagens/Apis_Video_Apontando_Esquerda_webm.webm' },
      layoutOverride: {
        character: {
          marginTop: '-30%',
        },
        controls: {
          top: 'calc(28% + 190px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_02_new_medication',
      text: 'Agora, toque em “Nova Medicação”.',
      gate: 'hard',
      anchor: 'menu-new-medication',
      waitFor: { type: 'click', anchor: 'menu-new-medication' },
      uiPosition: 'center',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_03_med_name',
      text: 'Digite o nome do medicamento homeopático (ex: Arnica Montana).',
      gate: 'hard',
      anchor: 'med-name',
      waitFor: { type: 'event', name: 'tutorial:med:name-filled' },
      waitAction: 'unlock',
      uiPosition: 'center',
      characterPose: 'feliz',
      layoutOverride: {
        character: {
          marginTop: '10%',
        },
        controls: {
          top: 'calc(68% + 190px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    
    // 06.x Campos da Medicação
    {
      id: 'first_run.step_06_05_potency_number',
      text: 'Defina o valor da potência (ex.: 6, 12, 30, 200).',
      gate: 'hard',
      anchor: 'med-potency-number',
      waitFor: { type: 'event', name: 'tutorial:med:potency-number-filled' },
      waitAction: 'unlock',
      uiPosition: 'center',
      layoutOverride: {
        character: {
          marginTop: '10%',
        },
        controls: {
          top: 'calc(68% + 190px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_06_potency_type',
      text: 'Selecione o tipo de potência (DH, CH ou M).',
      gate: 'hard',
      anchor: 'med-potency-type',
      waitFor: { type: 'event', name: 'tutorial:med:potency-type-selected' },
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_07_dosage_type',
      text: 'Escolha o tipo de dosagem: Glóbulos ou Gotas.',
      gate: 'hard',
      anchor: 'med-dosage-type',
      waitFor: { type: 'event', name: 'tutorial:med:dosage-type-selected' },
      uiPosition: 'center',
      layoutOverride: {
        character: {
          marginTop: '10%',
        },
        controls: {
          top: 'calc(68% + 190px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_08_dosage_quantity',
      text: 'Defina a quantidade por dose (ex.: 5 glóbulos ou 10 gotas).',
      gate: 'hard',
      anchor: 'med-dosage-quantity',
      waitFor: { type: 'event', name: 'tutorial:med:dosage-quantity-filled' },
      waitAction: 'unlock',
      uiPosition: 'center',
      layoutOverride: {
        character: {
          marginTop: '10%',
        },
        controls: {
          top: 'calc(68% + 190px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_09_start_date',
      text: 'Escolha a data de início do tratamento.',
      gate: 'hard',
      anchor: 'med-start-date',
      waitFor: { type: 'event', name: 'tutorial:med:start-date-filled' },
      waitAction: 'unlock',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_10_frequency',
      text: 'Selecione a frequência (Diário, Alternados, Semanal ou Personalizado).',
      gate: 'hard',
      anchor: 'med-frequency',
      waitFor: { type: 'event', name: 'tutorial:med:frequency-selected' },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_04_med_schedule',
      text: 'Defina pelo menos um horário para a dose (você pode adicionar mais).',
      gate: 'hard',
      anchor: 'med-schedule',
      waitFor: { type: 'event', name: 'tutorial:med:schedule-filled' },
      waitAction: 'unlock',
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_11_usage_days',
      text: 'Informe os dias de uso (quantos dias consecutivos tomar a medicação).',
      gate: 'hard',
      anchor: 'med-usage-days',
      waitFor: { type: 'event', name: 'tutorial:med:usage-days-filled' },
      waitAction: 'unlock',
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_12_pause_days',
      text: 'Se houver, informe os dias de interrupção entre os ciclos.',
      gate: 'hard',
      anchor: 'med-pause-days',
      waitFor: { type: 'event', name: 'tutorial:med:pause-days-filled' },
      waitAction: 'unlock',
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_13_total_period',
      text: 'Defina o período total do tratamento em meses.',
      gate: 'hard',
      anchor: 'med-total-period',
      waitFor: { type: 'event', name: 'tutorial:med:total-period-filled' },
      waitAction: 'unlock',
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_14_cycle_summary',
      text: 'Confira o Resumo do Ciclo com início, frequência, horários e duração.',
      gate: 'soft',
      anchor: 'cycle-summary',
      uiPosition: 'top',
      characterPose: 'olhando_para_baixo',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_15_save',
      text: 'Conclua tocando em "Salvar Medicação".',
      gate: 'hard',
      anchor: 'btn-save-medication',
      waitFor: { type: 'click', anchor: 'btn-save-medication' },
      uiPosition: 'center-inverted',
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando_Baixo.mov', webm: '/Imagens/Apis_Video_Apontando_Baixo_webm.webm' },
      layoutOverride: {
        character: {
          marginTop: '10%',
          scale: 1.20,
        },
        controls: {
          top: 'calc(68% - 220px)',
        },
      },
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_16_first_badge',
      text: 'Parabéns! Esta é sua primeira badge. Badges representam conquistas no app.....',
      gate: 'soft',
      overlay: false,  // Badge já tem seu próprio overlay
      characterVideo: { mov: '/Imagens/Apis_Video_Festa.mov', webm: '/Imagens/Apis_Video_Festa_webm.webm' },
      characterPose: 'comemorando',
      enableStaggeredAnimation: true,
    },
    {
      id: 'first_run.step_06_17_badge_explanation',
      text: '...e ajudam a acompanhar seu progresso. Toque no botão "Continuar" do badge para fechá-lo, ou clique em "Próximo".',
      gate: 'soft',  // Permite avanço manual com botão Próximo
      overlay: false,  // Badge já tem seu próprio overlay
      // Auto-advance: quando o badge fechar, avança automaticamente
      characterPose: 'feliz',
      enableStaggeredAnimation: true,
    },
    // 07 - Ativar Push + Alertas
    {
      id: 'first_run.step_07_01_push_intro',
      text: 'Uma dica da Apis: tomar as medicações no horário certo faz toda a diferença. Eu posso te avisar no celular quando estiver na hora. Vamos ativar os avisos?',
      gate: 'soft',
      uiPosition: 'center-down',
      characterVideo: { mov: '/Imagens/Apis_Video_Sino.mov', webm: '/Imagens/Apis_Video_Sino_webm.webm' },
      layoutOverride: {
        controls: {
          top: 'calc(72% + 120px)',
        },
      },
    },
    {
      id: 'first_run.step_07_02_go_settings',
      text: 'Toque em Configurações para seguirmos e ativar os avisos.',
      gate: 'hard',
      anchor: 'nav-settings',
      waitFor: { type: 'route', path: '/settings' },
      uiPosition: 'center-inverted',
      layoutOverride: {
        character: {
          marginTop: '15%',
          scale: 1.15,
        },
        controls: {
          top: 'calc(73% - 220px)',
        },
      },
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando_Baixo.mov', webm: '/Imagens/Apis_Video_Apontando_Baixo_webm.webm' },
    },
    {
      id: 'first_run.step_07_03_settings_intro',
      text: 'Chegamos às Configurações. Aqui você pode ativar os avisos para ser lembrado dos horários de tomar as medicações.',
      gate: 'hard',
      uiPosition: 'center',
    },
    {
      id: 'first_run.step_07_04_enable_push',
      text: 'Toque em Ativar. Assim você será avisado no celular sobre os horários das medicações, na hora certa.',
      gate: 'hard',
      anchor: 'btn-enable-push',
      waitFor: { type: 'click', anchor: 'btn-enable-push' },
      uiPosition: 'center',
      characterVideo: { mov: '/Imagens/Apis_Video_Apontando.mov', webm: '/Imagens/Apis_Video_Apontando_webm.webm' },
    },
    {
      id: 'first_run.step_07_05_go_home',
      text: 'Volte para a tela inicial tocando em Início.',
      gate: 'hard',
      anchor: 'nav-home',
      waitFor: { type: 'click', anchor: 'nav-home' },
      uiPosition: 'center',
    },
    {
      id: 'first_run.step_07_06_alerts_bell',
      text: 'Aqui ficam os alertas do dia. Toque para abrir.',
      gate: 'hard',
      anchor: 'btn-bell-alerts',
      waitFor: { type: 'click', anchor: 'btn-bell-alerts' },
      uiPosition: 'center',
      layoutOverride: {
        character: {
          marginTop: '-20%',
        },
        controls: {
          top: 'calc(58% + 190px - 20%)',
        },
      },
    },
    {
      id: 'first_run.step_07_07_alerts_panel',
      text: 'Este é o painel de alertas. Você verá doses atrasadas e outros avisos importantes.',
      gate: 'soft',
      anchor: 'alerts-panel',
      uiPosition: 'center',
    },
    // ========================================
    // EXEMPLOS DE LAYOUT OVERRIDES (V3)
    // Descomente para testar posicionamento customizado
    // ========================================
    /*
    {
      id: 'first_run.step_98_example_custom_position',
      text: 'Exemplo 1: Posicionamento customizado no canto superior esquerdo! 🎉',
      characterPose: 'feliz',
      gate: 'soft',
      layoutOverride: {
        character: {
          top: 100,        // 100px do topo
          left: 50,        // 50px da esquerda
          width: 150,      // Menor que o padrão (200px)
        },
        bubble: {
          top: 80,
          left: 200,       // À direita da Apis
          maxWidth: 280,
        },
        tail: {
          placement: 'left',
        },
      },
    },
    {
      id: 'first_run.step_98_example_mirrored',
      text: 'Exemplo 2: Apis espelhada à direita com escala maior!',
      characterPose: 'apontando',
      gate: 'soft',
      layoutOverride: {
        character: {
          top: '30%',
          right: 50,
          mirror: true,    // Espelhar horizontalmente
          scale: 1.5,      // 50% maior (usa CSS transform)
        },
        bubble: {
          top: '30%',
          right: 250,
          width: 300,
          textAlign: 'right',
        },
        tail: {
          placement: 'right',
        },
      },
    },
    {
      id: 'first_run.step_98_example_giant',
      text: 'Exemplo 3: Apis gigante (3x maior) centralizada!',
      characterPose: 'comemorando',
      gate: 'soft',
      layoutOverride: {
        character: {
          scale: 3,        // 3x maior
          bottom: '50%',
        },
        controls: {
          bottom: '5%',
        },
      },
    },
    {
      id: 'first_run.step_98_example_controls',
      text: 'Exemplo 4: Controles customizados no topo da tela.',
      characterPose: 'surpresa',
      gate: 'soft',
      layoutOverride: {
        controls: {
          top: 20,
          left: '50%',
          justifyContent: 'center',
          gap: 12,
        },
      },
    },
    */
    {
      id: 'first_run.step_99_finish',
      text: 'Parabéns! Tutorial concluído. Você poderá reabrir nas Configurações ou na Ajuda.',
      gate: 'soft',
      characterPose: 'comemorando',
      uiPosition: 'center',
      layoutOverride: {
        character: {
          scale: 1.2,
        },
      },
      characterVideo: { mov: '/Imagens/Apis_Video_Festa.mov', webm: '/Imagens/Apis_Video_Festa_webm.webm' },
    },
  ],
}
